import PropTypes from 'prop-types';
import Icon from "../Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AddressCardText = props => {
  const {
    location = {},
    serviceAreaText = null,
    className = '',
    iconColor = 'dark-grey'
  } = props;
  const icon = serviceAreaText ? 'Radar' : 'MapPin';
  const title = serviceAreaText || location.displayName;
  const text = serviceAreaText || "".concat(location.displayName, " (").concat(location.distance, ")");
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex items-center text-sm text-text-blue",
      children: [/*#__PURE__*/_jsx(Icon, {
        className: "mr-2",
        color: iconColor,
        icon: icon
      }), /*#__PURE__*/_jsx("p", {
        title: title,
        children: text
      })]
    })
  });
};
AddressCardText.propTypes = {
  /** className */
  className: PropTypes.string,
  /** location object via displayName and distance */
  location: PropTypes.shape({
    displayName: PropTypes.string,
    distance: PropTypes.string
  }),
  /** icon color */
  iconColor: PropTypes.string,
  /** text describing the service area */
  serviceAreaText: PropTypes.string
};
export default AddressCardText;
//# sourceMappingURL=AddressCardText.js.map